module.exports = __webpack_public_path__ + "static/media/2@1280w.2b273451.jpg";